<template>
<div>
	<v-data-table
		:headers="headers"
		:items="jobs"
		hide-actions
		class="elevation-1"
	>
		<template slot="items" slot-scope="props">
			<td>
				{{ employers[props.item.employer_id - 1] ? employers[props.item.employer_id - 1].name : '' }}
			</td>
			<td class="text-xs-left">{{ props.item.job_start }}</td>
			<td class="text-xs-left">{{ props.item.job_end }}</td>
			<td class="text-xs-center">
				<v-checkbox v-model="props.item.active_job"
					@change="editActiveJob(props.item, props.item.active_job)"
					:disabled="!props.item.active_job && activeJobSelected" />
			</td>
			<td class="text-xs-center">
				<v-tooltip top>
					<v-btn slot="activator" fab dark small color="indigo lighten-2" @click="edit(props.item)">
						<v-icon dark>edit</v-icon>
					</v-btn>
					<span>{{$t('common.edit')}}</span>
				</v-tooltip>

				<ConfirmDialog v-bind="propConfirmDialog"
					@accept="onDeleteJob(props.item.id)"
					:tooltip="$t('common.delete')"
				>
					<v-icon dark>delete</v-icon>
				</ConfirmDialog>
			</td>
		</template>
	</v-data-table>
	<v-layout row justify-end>
		<JobForm v-bind="propForm" :employers="employers" @cancel="cancel" @open="open" @save="save" />
	</v-layout>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import { HEADERS_TABLE_JOBS, TEMPLATE_FORM_JOB } from '../../../../constants'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import JobForm from './JobsForm'
import { notify } from '../../../../utils/notifications'
import { localeHeadersWorkers } from '../../../../utils/helpers'

export default {
	created() {
		this.getEmployers({
			count: 100
		})
	},
	components: {
		ConfirmDialog,
		JobForm
	},
	data: vm => ({
		propForm: {
			jobData: { ...TEMPLATE_FORM_JOB },
			dialog: false
		},
		headers: localeHeadersWorkers(HEADERS_TABLE_JOBS, vm.$t),
		propConfirmDialog: {
			message: vm.$t('workers.confirm_message_job'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2'
			}
		}
	}),
	computed: {
		jobs() {
			return this.$store.state.workers.workerDetail.jobs
		},
		employers() {
			return this.$store.state.employers.list
		},
		activeJobSelected() {
			let result = false
			this.jobs.map(item => {
				item.active_job
				? result = true
				: ''
			})
			return result
		}
	},
	methods: {
		...mapActions({
			createJob: 'workers/createJob',
			updateJob: 'workers/updateJob',
			deleteJob: 'workers/deleteJob',
			getEmployers: 'employers/fetch'
		}),
		cancel() {
			this.propForm.dialog = false
			this.propForm.jobData = { ...TEMPLATE_FORM_JOB }
		},
		open(edit = false) {
			this.propForm.dialog = true
			edit ? '' : this.setDataForm({ ...TEMPLATE_FORM_JOB })
		},
		save(job) {
			let func = this.createJob
			let message = 'created'
			if (job.id > 0) {
				func = this.updateJob
				message = 'updated'
			}
			func({ ...job }).then(() => {
				this.$notify({
					...notify,
					text: this.$t(`notifications.${message}`, { type: this.$t('workers.job')})
				})
			})
			this.cancel()
		},
		edit(data) {
			this.setDataForm(data)
			this.open(true)
		},
		onDeleteJob(id) {
			this.deleteJob(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', { type: this.$t('workers.job') })
				})
			})
		},
		setDataForm(data) {
			this.propForm.jobData = { ...data }
		},
		editActiveJob(jobData, value) {
			this.updateJob({...jobData})
			this.$notify({
				...notify,
				text: this.$t(`notifications.updated`, { type: this.$t('workers.job')})
			})
		}
	}
}
</script>
